import React, { Component, Fragment } from 'react';
import {
    Button,
    Icon,
    Table,
    Header,
    Segment,
    Popup,
    Loader,
    Responsive,
    Tab,
    Grid,
    Form,
    Label
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Redirect } from 'react-router';
import { IconHeader, FiltersOnStyle, HeaderCursor } from '../Professor/ProfessorInputGrades/css';
import HRFilters from './HRFilters';
import SelectOrgUnit from './SelectOrgUnit';
import {ExportReactCSV} from "../util/ExportCSV";
import SearchTableData from "../util/SearchTableData";
import PaginationFront from "../util/PaginationFront";
import { center } from '../Statistics/util';
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';
import moment from "moment";

const NoDataMessage = () => <p>Nema zaposlenika.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class EmployeeListAcademic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeTypes: [],
            data: [],
            showProfile: false,
            employeeTypeId: null,
            loading: true,
            statusLoaded: false,
            loadingRowId: null,

            activePage: 1,
            activeIndex: this.props.location.state? this.props.location.state.activeIndex: 0,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: [],
            excelDataOther: []
        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getEmployees = this.getEmployees.bind(this);
        this.getPersonAndEmployee = this.getPersonAndEmployee.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.getResults = this.getResults.bind(this);
    }
    UNSAFE_componentWillMount() {
        axios.get('employee-types')
            .then(res =>
                this.setState({
                    employeeTypes: res.data,
                    employeeTypeId: res.data.find(el => el._key === 'nastavno osoblje').id
                }))
            .then(re =>
                this.getEmployees());
        window.localStorage.removeItem('main');
        window.localStorage.removeItem('employee');
        window.localStorage.removeItem('person');
        window.localStorage.removeItem('academicStaff');
    }
    getEmployees() {
        const { employeeTypes } = this.state;
        let obj = {
            employeeTypeId: this.state.employeeTypeId,
            associateStaff: false
        };
        if (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') {
            obj = {
                organizationalUnitId: parseInt(localStorage.getItem('orgUnitId')),
                employeeTypeId: this.state.employeeTypeId,
                associateStaff: false
            };
        }
        this.state.employeeTypeId && axios.post('employees/by-organizational-unit', { ...obj })
            .then(res => {
                this.setState({ data: res.data, loading: false });

                const excelData = this.state.data.filter(el => el.main).map(el => ([
                    { value: el.employeeLastName},
                    { value: el.employeeFirstName },
                    { value: String(el.employeeJmbg)},

                ]));
                this.setState({excelData: excelData});

                const excelDataOther = this.state.data.filter(el => !el.main).map(el => ([
                    { value: el.employeeLastName},
                    { value: el.employeeFirstName },
                    { value: String(el.employeeJmbg)},

                ]));
                this.setState({excelDataOther: excelDataOther});
            })
            .catch(err => {
                console.log('Failed to fetch (all) employees');
            });

        this.state.employeeTypeId && axios.post('employees/with-pio-mio-by-organizational-unit', { ...obj })
            .then(res => {
                this.setState({ data: res.data, statusLoaded: true});

                const excelData = this.state.data.filter(el => el.main).map(el => ([
                    { value: el.employeeLastName },
                    { value: el.employeeFirstName },
                    { value: String(el.employeeJmbg) },
                    { value:
                            (el.dateEnd && el.dateEnd < new Date() ? 'Istekao angažman' : '') +
                            ((el.dateEnd && el.dateEnd < new Date()) &&
                            (el.pioMioList.length && el.pioMioList[0].endDate && el.pioMioList[0].endDate < new Date()) ? ', ' : '') +
                            (el.pioMioList.length && el.pioMioList[0].endDate && el.pioMioList[0].endDate < new Date() ? 'Odjavljen sa PIO/MIO' : '')
                    },
                ]));
                this.setState({excelData: excelData});

                const excelDataOther = this.state.data.filter(el => !el.main).map(el => ([
                    { value: el.employeeLastName },
                    { value: el.employeeFirstName },
                    { value: String(el.employeeJmbg) },
                    { value:
                            (el.dateEnd && el.dateEnd < new Date() ? 'Istekao angažman' : '') +
                            ((el.dateEnd && el.dateEnd < new Date()) &&
                            (el.pioMioList.length && el.pioMioList[0].endDate && el.pioMioList[0].endDate < new Date()) ? ', ' : '') +
                            (el.pioMioList.length && el.pioMioList[0].endDate && el.pioMioList[0].endDate < new Date() ? 'Odjavljen sa PIO/MIO' : '')
                    },
                ]));
                this.setState({excelDataOther: excelDataOther});
            })
            .catch(err => {
                console.log('Failed to fetch (all) employees');
            });
    }
    getPersonAndEmployee(jmbg, id, main, rowId) {
        this.setState({ loadingRowId: rowId });
        localStorage.setItem('main', main);
        if (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') {
            localStorage.setItem('main', 'false');
        }
        let obj = {
            jmbg
        };
        axios.post('hr/get-person-by-jmbg/', { ...obj })
            .then(res => {
                localStorage.setItem('person', JSON.stringify(res.data[0]));
                axios.get(`employees/${id}`)
                    .then(res => {
                        localStorage.setItem('employee', JSON.stringify(res.data));
                        res.data.associateStaff ? localStorage.setItem('associate', 'true') : localStorage.setItem('associate', 'false');
                        if (res.data.employeeType._key === 'nastavno osoblje') localStorage.setItem('academicStaff', 'true');
                        if (res.data.employeeType._key === 'nenastavno osoblje') localStorage.setItem('academicStaff', 'false');
                        this.setState({ showProfile: true, loadingRowId: null });
                    })
                    .catch(() => this.setState({ loadingRowId: null }));
            })
            .catch(() => this.setState({ loadingRowId: null }));
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.activeIndex === 0) {
            return this.state.data.filter(el => el.main);
        }
        if (this.state.activeIndex === 1) {
            return this.state.data.filter(el => !el.main);
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    handleTabChange(e, { activeIndex }) {
        this.setState({ activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            activeIndex,

            results: []});
        this.handlePaginationChange({}, { activePage: 1 })
    }
    render() {

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 200 } },
                    { title: 'JMBG', width: { wpx: 150 }},
                    { title: 'Status', width: { wpx: 250 }},
                ],
                data: this.state.excelData,
            }
        ];

        const multiDataSetOther = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 200 } },
                    { title: 'JMBG', width: { wpx: 150 }},
                    { title: 'Status', width: { wpx: 250 }},
                ],
                data: this.state.excelDataOther,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        if (this.state.showProfile) return <Redirect push to={{ pathname: '/nastavno-i-naučno-istraživačko-osoblje/informacije-o-zaposleniku' }} />;
        const panes = [
            {
                menuItem: 'Matična organizaciona jedinica',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        {this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                            : <div>
                                {currentPosts.length ?
                                    <div>
                                        <br/>
                                        <Table celled selectable compact >
                                            <Table.Header>
                                                {/*<Table.Row>*/}
                                                {/*    <Table.HeaderCell colSpan={12}>*/}

                                                {/*                <Grid columns={2} stackable>*/}

                                                {/*                        <Grid.Column width={1}>*/}
                                                {/*                            <ExportReactCSV color="green" disabled={this.getDataToRender().length === 0} csvData={this.getDataToRender()} headers={headersForExport} floated="right" fileName="Spisak zaposlenika na matičnoj organizacionoj jedinici" />*/}
                                                {/*                        </Grid.Column>*/}
                                                {/*                     <Grid.Column width={15}>*/}
                                                {/*                        <SearchTableData data={this.getDataToRender()} getResults={this.getResults} filterItem={['employeeLastName', 'employeeFirstName', 'employeeJmbg']} />*/}
                                                {/*                      </Grid.Column>*/}


                                                {/*                     </Grid>*/}


                                                {/*    </Table.HeaderCell>*/}
                                                {/*</Table.Row>*/}
                                                <Table.Row>
                                                    <Table.HeaderCell colSpan={13} >
                                                        <Grid columns={2} stackable>

                                                            <Grid.Column width={14}>
                                                                <SearchTableData key={1} profMozilla data={this.state.data.filter(el => el.main)} getResults={this.getResults} disabled={false} filterItem={['employeeLastName', 'employeeFirstName', 'employeeJmbg']} />
                                                            </Grid.Column>
                                                            <Grid.Column width={2} textAlign={'center'}>
                                                                <ExcelFile filename="Spisak zaposlenika na matičnoj organizacionoj jedinici" element={<Popup
                                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                        <Button.Content visible>
                                                                            Excel
                                                                        </Button.Content>
                                                                    </Button>}
                                                                    content="Preuzmi spisak u Excel-u"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />}>
                                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Zaposlenici" />
                                                                </ExcelFile>
                                                                {/*<ExportReactCSV icon color="green" disabled={this.getDataToRender().length === 0} fluid csvData={this.getDataToRender()} headers={headersForExport} fileName="Spisak zaposlenika na matičnoj organizacionoj jedinici" />*/}
                                                            </Grid.Column>
                                                        </Grid>
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.HeaderCell>R. br.</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={5}>Prezime i ime</Table.HeaderCell>
                                                    {/*<Table.HeaderCell colSpan={3}>Ime</Table.HeaderCell>*/}
                                                    <Table.HeaderCell colSpan={2}>JMBG</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}>Status</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={2} />
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {currentPosts.map((el, index) =>
                                                    (<Popup
                                                        trigger={<Table.Row
                                                            key={index}
                                                            style={HeaderCursor}
                                                            onClick={() => {
                                                                localStorage.setItem('organizationalUnitEmployeeId', el.id);
                                                                this.getPersonAndEmployee(el.employeeJmbg, el.employeeId, el.main, el.id)
                                                            }}
                                                        >
                                                            <Table.Cell verticalAlign="middle">
                                                                {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.

                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={5}>
                                                                {el.employeeLastName} {el.employeeFirstName}
                                                            </Table.Cell>
                                                            {/*<Table.Cell verticalAlign="middle" colSpan={3}>*/}
                                                            {/*    {el.employeeFirstName}*/}
                                                            {/*</Table.Cell>*/}
                                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                                {el.employeeJmbg}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                <span>
                                                                {this.state.statusLoaded ? el.dateEnd && el.dateEnd < new Date()? <Label style={{ margin: 2}}>Istekao angažman</Label>: null :<div><Loader size={'mini'} inline="centered" active/></div>}
                                                                {this.state.statusLoaded && el.pioMioList && el.pioMioList.length && el.pioMioList[0].endDate && el.pioMioList[0].endDate < new Date()? <Label style={{ margin: 2}}>Odjavljen sa PIO/MIO</Label>: null}
                                                                </span>
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan={2}>
                                                                <Button
                                                                    basic="true"
                                                                    color="blue"
                                                                    size="small"
                                                                    loading={this.state.loadingRowId === el.id}
                                                                    disabled={this.state.loadingRowId === el.id}
                                                                    onClick={() => {
                                                                        localStorage.setItem('organizationalUnitEmployeeId', el.id);
                                                                        this.getPersonAndEmployee(el.employeeJmbg, el.employeeId, el.main, el.id);
                                                                    }}
                                                                >
                                                                   Detalji
                                                                </Button>
                                                            </Table.Cell>
                                                        </Table.Row>}
                                                        content="Prikaz detalja o zaposleniku"
                                                        hideOnScroll
                                                        position="left center"
                                                    />))}
                                            </Table.Body>
                                        </Table>
                                    </div>
                                    : <NoDataMessage />
                                }
                                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                            </div>}
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: 'Ostale organizacione jedinice',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        {this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                            : <div>
                                {currentPosts.length ?
                                    <div>
                                        <br/>
                                        <Table celled selectable compact >
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell colSpan={13} >

                                                        <Grid columns={2} stackable>

                                                            <Grid.Column width={14}>
                                                                <SearchTableData key={2} profMozilla data={this.state.data.filter(el => !el.main)} getResults={this.getResults} disabled={false} filterItem={['employeeLastName', 'employeeFirstName', 'employeeJmbg']} />
                                                            </Grid.Column>
                                                            <Grid.Column width={2} textAlign={'center'}>
                                                                <ExcelFile filename="Spisak zaposlenika na ostalim organizacionim jedinicama" element={<Popup
                                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                        <Button.Content visible>
                                                                            Excel
                                                                        </Button.Content>
                                                                    </Button>}
                                                                    content="Preuzmi spisak u Excel-u"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />}>
                                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSetOther)} name="Zaposlenici" />
                                                                </ExcelFile>
                                                                {/*<ExportReactCSV icon color="green" disabled={this.getDataToRender().length === 0} fluid csvData={this.getDataToRender()} headers={headersForExport} fileName="Spisak zaposlenika na ostalim organizacionim jedinicama" />*/}
                                                            </Grid.Column>
                                                        </Grid>


                                        {/*<span> {<ExportReactCSV disabled={this.getDataToRender()} color="green" csvData={this.getDataToRender()} headers={headersForExport} floated="right" fileName="Spisak zaposlenika na ostalim organizacionim jedinicama" />}*/}
                                        {/*    <SearchTableData data={this.getDataToRender()} getResults={this.getResults} filterItem={['employeeLastName', 'employeeFirstName', 'employeeJmbg']} />*/}
                                        {/*</span>*/}
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.HeaderCell>R. br.</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={4}>Prezime i ime</Table.HeaderCell>
                                                    {/*<Table.HeaderCell colSpan={2}>Ime</Table.HeaderCell>*/}
                                                    <Table.HeaderCell colSpan={3}>JMBG</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}>Status</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={2}/>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {currentPosts.map((el, index) =>
                                                    (<Popup
                                                        trigger={<Table.Row
                                                            key={index}
                                                            style={HeaderCursor}
                                                            onClick={() => this.getPersonAndEmployee(el.employeeJmbg, el.employeeId, el.main, el.id)}
                                                        >
                                                            <Table.Cell verticalAlign="middle">
                                                                {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.

                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={4}>
                                                                {el.employeeLastName} {el.employeeFirstName}
                                                            </Table.Cell>
                                                            {/*<Table.Cell verticalAlign="middle" colSpan={2}>*/}
                                                            {/*    {el.employeeFirstName}*/}
                                                            {/*</Table.Cell>*/}
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                {el.employeeJmbg}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                 <span>
                                                                {this.state.statusLoaded ? el.dateEnd && el.dateEnd < new Date()? <Label style={{ margin: 2}}>Istekao angažman</Label>: null :<div><Loader size={'mini'} inline="centered" active/></div>}
                                                                {this.state.statusLoaded && el.pioMioList && el.pioMioList.length && el.pioMioList[0].endDate && el.pioMioList[0].endDate < new Date()? <Label style={{ margin: 2}}>Odjavljen sa PIO/MIO</Label>: null}
                                                                 </span>
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan={2}>
                                                                <Button
                                                                    basic="true"
                                                                    color="blue"
                                                                    size="small"
                                                                    loading={this.state.loadingRowId === el.id}
                                                                    disabled={this.state.loadingRowId === el.id}
                                                                    onClick={() => this.getPersonAndEmployee(el.employeeJmbg, el.employeeId, el.main, el.id)}
                                                                >
                                                                    Detalji
                                                                </Button>
                                                            </Table.Cell>
                                                        </Table.Row>}
                                                        content="Prikaz detalja o zaposleniku"
                                                        hideOnScroll
                                                        position="left center"
                                                    />))}
                                            </Table.Body>
                                        </Table>
                                    </div>
                                    : <NoDataMessage />
                                }
                                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                            </div>}
                    </div>
                </Tab.Pane>)
            }
        ];
        return (
            <div>
                <h1> Nastavno / naučno-istraživačko osoblje </h1>
                <Segment.Group raised>
                    {localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' &&
                    <Segment>
                        <h3>Lista zaposlenika</h3>
                    </Segment>}
                    {localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' && <Segment><SelectOrgUnit getEmployees={this.getEmployees} /></Segment>}
                    {(localStorage.getItem('orgUnitId') || localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Fragment>
                        {localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' &&  <Segment clearing>
                            <Header as="h3">
                                Lista zaposlenika
                            </Header>
                        </Segment>}
                        <Segment><Tab
                            menu={{
                                secondary: true, pointing: true, color: 'blue', fluid: true, attached: true, tabular: true
                            }}
                            grid={{ paneWidth: 13, tabWidth: 3 }}
                            panes={panes}
                            activeIndex={this.state.activeIndex}
                            onTabChange={this.handleTabChange}
                        /></Segment>
                    </Fragment>}
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/EmployeeListAcademic.js